// extracted by mini-css-extract-plugin
export var dividerLine = "_8o-3";
export var itemImage = "_8o-9";
export var lightDivider = "_8o-4";
export var modalContent = "_8o-5";
export var modalContentCompact = "_8o-6";
export var productCard = "_8o-a";
export var productImage = "_8o-b";
export var productImageCompact = "_8o-7";
export var productImagePlaceholder = "_8o-c";
export var productImagePlaceholderCompact = "_8o-8";
export var progressBarBackground = "_8o-1";
export var progressBarContainer = "_8o-0";
export var progressBarFill = "_8o-2";